export const DEFAULT_SEARCH_BRAND_CODE = "MWD"


// WEBPACK FOOTER //
// ./src/constants/defaultValues.js